// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__2g0xK","inner":"Form_inner__27exW","range":"Form_range__3dK5Q","name":"Form_name__3b-hC","actions":"Form_actions__1X4q5"};